"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContentNameContainer;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _ContentName = _interopRequireDefault(require("./ContentName"));

var s = {
  contentNameContainer:
  /*#__PURE__*/
  (0, _emotion.css)("display:flex;justify-content:space-between;align-items:center;"),
  contentName:
  /*#__PURE__*/
  (0, _emotion.css)("font-size:16px !important;margin:2px 0px !important;")
};

function ContentNameContainer(props) {
  var ContentNameRightContent = props.ContentNameRightContent;
  return _react.default.createElement("div", {
    className: s.contentNameContainer
  }, _react.default.createElement(_ContentName.default, (0, _extends2.default)({}, props, {
    className: s.contentName,
    trimLength: -1
  })), ContentNameRightContent);
}